import { combineReducers } from 'redux';
import { value } from './value';
import { options } from './options';

export const legs = combineReducers( {
  value,
  options
} );
